import { render, staticRenderFns } from "./LauncherFooter.vue?vue&type=template&id=291f611a&scoped=true&"
import script from "./LauncherFooter.vue?vue&type=script&lang=js&"
export * from "./LauncherFooter.vue?vue&type=script&lang=js&"
import style0 from "./LauncherFooter.vue?vue&type=style&index=0&id=291f611a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f611a",
  null
  
)

export default component.exports